export default "__VITE_ASSET__CmV3to8e__"